<template>
  <div 
    style="width:1080px;height:980px;background-size:cover;"
    :style="{ 'background-image': `url(${totemItemImage})` }"
  >
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app',['totemActiveMenu', 'totemItemImage']),
  }
}
</script>
<style scope>
</style>

